export type SortDirection = 'ascending' | 'descending'

export interface TableSort {
    key: string
    direction: SortDirection
}

export type SortValue = string | number | null

export function nextSort(current: TableSort | null, key: string): TableSort | null {
    if (!current || current.key !== key) {
        return { key, direction: 'ascending' }
    }
    return current.direction === 'ascending' ? { key, direction: 'descending' } : null
}

const compareValues = (a: string | number, b: string | number): number => {
    if (typeof a === 'number' && typeof b === 'number') {
        return a - b
    }
    return String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' })
}

export function sortRows<T>(rows: T[], sort: TableSort | null, valueOf: (row: T, key: string) => SortValue): T[] {
    if (!sort) {
        return rows
    }
    const factor = sort.direction === 'ascending' ? 1 : -1
    return rows
        .map((row, index) => ({ row, index, value: valueOf(row, sort.key) }))
        .sort((a, b) => {
            if (a.value === null || b.value === null) {
                if (a.value === b.value) {
                    return a.index - b.index
                }
                return a.value === null ? 1 : -1
            }
            const diff = compareValues(a.value, b.value)
            return diff !== 0 ? diff * factor : a.index - b.index
        })
        .map((entry) => entry.row)
}
